import { ProductImageRendition } from "@omni/types/api/product/shared/enums/productImageRendition.enum";
import { Media } from "@omni/types/api/shared/bff/media.model";
import classnames from "classnames";

import { Image } from "@/components/Product/ProductImage/imageWrapper/image/image.component";
import { EmptyImages } from "@/utils/enums";

import "./imageWrapper.scss";

import { DamImage } from "@/utils/dam.utils";

type Props = {
    title: string | undefined;
    medias: null | Array<Media>;
    isEcoChequesAccepted: boolean;
    rendition?: ProductImageRendition;
    className?: string;
    lazyLoad?: boolean;
    parentFit?: boolean;
};

const ProductImage = ({
    title,
    medias,
    isEcoChequesAccepted,
    rendition,
    className,
    lazyLoad = false,
    parentFit = false
}: Props) => {
    return (
        <div className={classnames("productImage-wrapper")}>
            {isEcoChequesAccepted && (
                <div className="productImage-wrapper__eco-label">
                    <img
                        className="productImage-wrapper__label"
                        src={DamImage.icon.label.eco}
                        alt="ecocheques"
                    />
                </div>
            )}
            {medias && (
                <Image
                    className={classnames(
                        "productImage-wrapper__image",
                        className
                    )}
                    medias={medias}
                    altText={title}
                    defaultImageUrl={EmptyImages.Size_146_109}
                    rendition={rendition}
                    lazyLoad={lazyLoad}
                    parentFit={parentFit}
                />
            )}
        </div>
    );
};

export { ProductImage };
